<template>
  <div class="full-height">
    <amf-form :title=title class="container">
      <div v-if="busy">Loading...</div>

      <div v-if="!busy && nachas.length == 0">No nachas</div>

      <div class="nacha-list">
        <div v-if="!busy && nachas.length > 0">
          <table class="table table-hover table-bordered table-sm table-accounts">
            <thead>
              <tr>
                <th>File Name</th>
                <th>Created Date</th>
                <th>Downloaded Date</th>
                <th>Record Count</th>
                <th>Claims Total</th>
                <th>Actions</th>
                <th>Nacha Status</th>
              </tr>
            </thead>
            <tbody v-for="n in nachas" :key="n.id">
              <tr>
                <td>
                  <a href="#" @click.prevent="download(n.nachaId)">{{n.fileName}}</a>
                </td>
                <td>{{$formatters.date(n.createdAt)}}</td>
                <td>
                  <span v-if="n.fileDownloadedAt">{{$formatters.date(n.fileDownloadedAt)}}</span>
                  <span v-else></span>
                </td>
                <td>{{n.bankTransferCount}}</td>
                <td>${{n.total}}</td>
                <td>
                  <button
                    @click="openNachaDetail(n.nachaId, type.id)"
                    class="btn btn-sm btn-default"
                  >Confirm Status</button>
                </td>

                <td>
                  <span v-if="n.status">
                    <i class="fa fa-check-circle" style="color:green"></i>
                  </span>
                  <span v-else>
                    <i class="fa fa-times-circle" style="color:red"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </amf-form>
  </div>
</template>

<script>
import NachaModal from "./NachaDetail";
export default {
  props: { type: Object },
  components: {
    NachaModal,
  },
  data() {
    return {
      fullNachas: [],
      filteredNachas: [],
      payTypes: { manualClaim: 1, substantiation: 2, hsaFunding: 3 },
      accountTypes: {achDeposit:1, achDebit:2,hsaDeposit:3, hsaDebit: 4},
      fullList: null,
    };
  },
  computed: {
    menuItems() {
      var list = [];
      if(this.fullList == null || this.fullList == "false")
      {
        list.push("Show Full List");
      }
      return list;
    },
    payType() {
      return this.$route.params.payType;
    },
    title()
    {
      return this.type.title;
    },
    nachas()
    {
      if(this.fullList) return this.fullNachas;
      else return this.filteredNachas;
    }
  },
  methods: {
    async load() {
      this.busy = true;

      var obj =
      {
        abaId: this.type.bankAccount.ameriflexBankAccountId,
        direction: this.type.direction
      };

      await this.$store.dispatch("nachas/loadNachaByAccountType", obj);
      this.nachaLoaded = true;
      this.filteredNachas = this.$store.getters["nachas/nachas"];

      this.busy = false;
    },
    openNachaDetail(nachaId, typeId) {
      this.$router.push({
        path: `/nacha/nachadetail/${nachaId}`,
        query: { typeId: typeId},
      });
    },
    async download(nachaId) {
      await romeApi.download(`participant/nacha/${nachaId}/txt/download/${this.type.id}`);
      this.load();
    },
    async showFullList()
    {
      this.busy = true;
      var obj =
      {
        abaId: this.type.bankAccount.ameriflexBankAccountId,
        direction: this.type.direction
      };
      var fullNachas = await romeApi.get(`participant/nacha/all`,obj);
      this.fullNachas = fullNachas.sort((a,b)=> (b.createdAt > a.createdAt) ? 1 : -1)
      this.fullList = true;
      this.busy = false;
    },
  },
  watch:{
    payType(newValue)
    {
      if(!newValue) return;
      this.load();
    },
  },
  created() {
    this.load();
  },

};
</script>

<style lang="scss" scoped>
.nacha-list {
  height: 100%;
  overflow-y: scroll;
  a {
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/finance/NachaList.vue